import request from "@/utils/request";

export function getSulzerProductPage(data) {
  return request({
    url: `/pass/sulzerproduct/getSulzerProductPage`,
    method: "get",
    params: data,
  });
}

export function getSulzerProductInfoFilePage(data) {
  return request({
    url: `/pass/sulzerproductinfo/getSulzerProductInfoFilePage`,
    method: "get",
    params: data,
  });
}

export function getSulzerProductInfoPage(data) {
  return request({
    url: `/pass/sulzerproductinfo/getSulzerProductInfoPage`,
    method: "get",
    params: data,
  });
}

export function sulzerproduct(productId) {
  return request({
    url: `/pass/sulzerproduct/${productId}`,
    method: "get",
  });
}

export function getSulzerVideoPage(data) {
  return request({
    url: `/pass/sulzervideo/getSulzerVideoPage`,
    method: "get",
    params: data,
  });
}
